import React from 'react';
import { makeStyles, type Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@mui/material/Autocomplete';

const useStyles = makeStyles((theme: Theme) => ({
  fromControl: {
    width: '100%',
  },
}));

export default function Fields(props: any) {
  const classes = useStyles();
  const editFields = props.editFields;

  function handleFieldChange(key: string, value: any) {
    let updateFieldProps = {};
    updateFieldProps = { ...updateFieldProps, [key]: value };
    const find = editFields.find((f: any) => f.name === key);
    if (find && typeof find?.onChange === 'object' && find?.onChange?.length) {
      for (let i = 0; i < find.onChange.length; i++) {
        const onChnageName = find.onChange[i];
        const onChnageObj = editFields.find((f: any) => f.name === onChnageName);
        const val = onChnageObj.populate({ ...props.inheritState, [key]: value });

        updateFieldProps = {
          ...updateFieldProps,
          [onChnageName]: val,
        };
      }
    }

    props.onFieldStateUpdate({
      ...props.inheritState,
      ...updateFieldProps,
    });
  }

  // for enums
  const [inputValue, setInputValue]: [any, any] = React.useState({});

  return (
    <Grid container>
      {editFields?.map((f: any, i: any) => {
        if (f.type === 'text') {
          return (
            <Grid item xs={12} md={4} key={`${f.name}-${i}-TextField`}>
              <TextField
                fullWidth
                required={f.required}
                disabled={f.disabled}
                // defaultValue={props.inheritState[`${f.name}`]}
                label={f.label}
                value={props?.inheritState?.[`${f.name}`] ?? ''}
                onChange={(e) => {
                  handleFieldChange(`${f.name}`, e.target.value);
                }}
                className={classes.fromControl}
              />
              <br />
              <br />
            </Grid>
          );
        }
        if (f.type === 'number') {
          return (
            <Grid item xs={8} md={4} key={`${f.name}-${i}-TextField-number`}>
              <TextField
                fullWidth
                type="number"
                required={f.required}
                disabled={f.disabled}
                // defaultValue={props.inheritState[`${f.name}`]}

                label={f.label}
                value={props.inheritState?.[`${f.name}`] ?? null}
                onChange={(e) => {
                  handleFieldChange(`${f.name}`, e.target.value ?? null);
                }}
                className={classes.fromControl}
              />
              <br />
              <br />
            </Grid>
          );
        }
        if (f.type === 'enumeration') {
          const data = f.data;
          let defaultValue = '';
          for (let i = 0; i < data.length; i++) {
            const n = data[i];
            if (String(n.value) === String(props.inheritState[`${f.name}`])) {
              defaultValue = n.label;
              break;
            }
          }

          return (
            <Grid item xs={8} md={4} key={`${f.name}-${i}-enumeration`}>
              <Autocomplete
                fullWidth
                freeSolo
                value={defaultValue}
                onChange={(event, newValue: any) => {
                  handleFieldChange(`${f.name}`, newValue?.value ?? '');
                }}
                inputValue={defaultValue ?? inputValue[`${f.name}`] ?? ''}
                onInputChange={(event, newInputValue) => {
                  setInputValue({
                    ...inputValue,
                    [`${f.name}`]: newInputValue,
                  });
                }}
                id="controllable-states-demo"
                renderInput={(params) => <TextField {...params} label={f.label} />}
                options={data}
              />
              <br />
              <br />
            </Grid>
          );
        }
        return '';
      })}
    </Grid>
  );
}
